import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import OptimizedImage from '../common/OptimizedImage';

const PlayerCard = ({ player, index }) => (
  <Link to={`/players/${player.id}`} className="cab-player-card" aria-label={`Shop ${player.name} collection`} style={{ '--card-index': index }}>
    {player.image && <OptimizedImage src={player.image} alt={`${player.name} wearing CAB colours`} sizes="(max-width: 640px) 78vw, 33vw" />}
    <div className="cab-player-card__wash" />
    <span className="cab-player-card__number" aria-hidden="true">{player.number}</span>
    <div className="cab-player-card__content">
      <span className="cab-player-card__label">SHOP PLAYER / {player.position}</span>
      <h3>{player.name}</h3>
      <div className="cab-player-card__meta"><span>#{player.number}</span><span>{player.position}</span></div>
      <span className="cab-player-card__cta">Voir la collection <ArrowUpRight size={16} /></span>
    </div>
  </Link>
);

export default PlayerCard;
